import React, { useState } from 'react';

const INDUSTRIES = [
    'Web Development',
    'Restaurant',
    'Law Firm',
    'Medical Practice',
    'Salon/Spa',
    'Consulting',
    'Real Estate',
    'Retail',
    'E-commerce',
    'Photography',
    'Marketing Agency',
    'Financial Services',
    'Education',
    'Construction',
    'Other',
];

const Step1BasicInfo = ({ data, onChange }) => {
    const [errors, setErrors] = useState({});

    const validate = (field, value) => {
        const newErrors = { ...errors };
        if (field === 'business_name') {
            if (!value.trim()) {
                newErrors.business_name = 'Business name is required.';
            } else if (value.trim().length > 255) {
                newErrors.business_name = 'Business name must be 255 characters or fewer.';
            } else {
                delete newErrors.business_name;
            }
        }
        if (field === 'tagline') {
            if (value.length > 100) {
                newErrors.tagline = 'Tagline must be 100 characters or fewer.';
            } else {
                delete newErrors.tagline;
            }
        }
        if (field === 'industry') {
            if (!value) {
                newErrors.industry = 'Please select an industry.';
            } else {
                delete newErrors.industry;
            }
        }
        setErrors(newErrors);
    };

    const handleChange = (field, value) => {
        validate(field, value);
        onChange(field, value);
    };

    return (
        <div>
            <h2 className="step-title">Basic Information</h2>
            <p className="step-subtitle">Tell us about your business to get started.</p>

            <div className="form-group">
                <label className="form-label">
                    Business Name <span className="required">*</span>
                </label>
                <input
                    type="text"
                    className={`form-input ${errors.business_name ? 'error' : ''}`}
                    placeholder="e.g. Acme Corporation"
                    value={data.business_name}
                    onChange={(e) => handleChange('business_name', e.target.value)}
                    maxLength={255}
                />
                {errors.business_name && (
                    <span className="field-error">{errors.business_name}</span>
                )}
            </div>

            <div className="form-group">
                <label className="form-label">Tagline</label>
                <input
                    type="text"
                    className={`form-input ${errors.tagline ? 'error' : ''}`}
                    placeholder="e.g. Building the future, one project at a time"
                    value={data.tagline}
                    onChange={(e) => handleChange('tagline', e.target.value)}
                    maxLength={100}
                />
                <div className="char-counter">
                    {data.tagline.length}/100
                </div>
                {errors.tagline && (
                    <span className="field-error">{errors.tagline}</span>
                )}
            </div>

            <div className="form-group">
                <label className="form-label">
                    Industry <span className="required">*</span>
                </label>
                <select
                    className={`form-select ${errors.industry ? 'error' : ''}`}
                    value={data.industry}
                    onChange={(e) => handleChange('industry', e.target.value)}
                >
                    <option value="">— Select an industry —</option>
                    {INDUSTRIES.map(ind => (
                        <option key={ind} value={ind}>{ind}</option>
                    ))}
                </select>
                {errors.industry && (
                    <span className="field-error">{errors.industry}</span>
                )}
            </div>
        </div>
    );
};

export default Step1BasicInfo;
